var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44025 0.420335C7.31761 0.379338 7.18806 0.357875 7.05625 0.35791C6.38088 0.36533 5.83304 0.906942 5.81791 1.58218V5.42387H1.59627C1.27285 5.42385 0.96288 5.55328 0.735514 5.78329C0.508149 6.0133 0.382308 6.32475 0.386068 6.64815C0.39255 7.2317 0.802373 7.71893 1.35124 7.84247C1.44742 7.86894 1.54835 7.88412 1.65251 7.88649H12.474H12.5584C13.2235 7.8712 13.7547 7.32752 13.7545 6.66222C13.7583 6.33882 13.6325 6.02737 13.4051 5.79736C13.2653 5.65597 13.0943 5.55259 12.9082 5.49392C12.7747 5.44637 12.6326 5.42218 12.4881 5.42387H8.3227V1.59625C8.3227 1.03874 7.95005 0.568271 7.44025 0.420335ZM5.84607 10.9542V12.3614C5.83008 13.0348 6.35524 13.5975 7.02813 13.6279C7.35288 13.6393 7.66884 13.5211 7.90639 13.2994C8.14395 13.0777 8.28362 12.7706 8.29462 12.4459V10.8979C8.30987 10.5721 8.19299 10.254 7.97047 10.0156C7.74794 9.77717 7.43861 9.63866 7.11256 9.63143C6.78781 9.62004 6.47186 9.73822 6.2343 9.95994C5.99674 10.1817 5.85708 10.4887 5.84607 10.8135V10.9542Z",
    fill: "#200E32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.079294c1.svg";
export { ForwardRef as ReactComponent };